import React, { useState, useEffect } from "react";
import { format } from 'date-fns';

import styles from './SubscriptionInfo.module.scss'

export const SubscriptionInfo = ({
    subscription,
    showDates=false, 
    showMaxUsers=true, 
    border=true,
    showType=false,  
    maxWidth="450px",
    props
}) => {

    return(
        <div 
            style={{maxWidth: maxWidth}}
            className={`
                ${styles["each-subscription-wrapper"]}
                ${styles[border ? "border" : ""]}
            `}
        >
            {showType &&
                <p>
                    <span className={`
                        ${styles["sub-status"]}
                        ${styles[subscription?.subscription_status]}
                    `}>
                        {subscription?.subscription_status === "Active" 
                            ? <i className="far fa-lightbulb" style={{paddingLeft:"5px", paddingRight:"4px"}}/>
                            : <i className="far fa-lightbulb-slash" />
                        }
                        {subscription?.subscription_status} Subscription
                    </span>
                </p>
            }
            <p>
                <span className={styles["sub-name"]}>
                    {subscription?.product_name} {subscription?.product_variant_name?.trim()!=="Default" ? subscription?.product_variant_name : ""}
                </span>
            </p>
            {showMaxUsers && subscription?.subscription_max_users > 1 &&
                <p>
                    <span className={styles["bold"]}>
                        {subscription?.subscription_type_name} Subscription - 
                    </span>
                    Max Users: {subscription?.subscription_max_users}
                </p>
            }
            {showDates &&
                <ul className={styles["sub-dates"]}>
                    <li>
                        <span className={styles["bold"]}>
                            Last Bill Date - 
                        </span>
                        {format(new Date(subscription?.last_bill_date), "MM/dd/yy")}
                    </li>
                    <li>
                        <span className={styles["bold"]}>
                            Next Bill Date - 
                        </span>
                        {format(new Date(subscription?.next_bill_date), "MM/dd/yy")}
                    </li>
                </ul>
            }
        </div>
    )
}
